import { render, staticRenderFns } from "./StoreyTitle.vue?vue&type=template&id=1a64d3c9&"
import script from "./StoreyTitle.vue?vue&type=script&lang=js&"
export * from "./StoreyTitle.vue?vue&type=script&lang=js&"
import style0 from "./StoreyTitle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports